export const TASK_SCOPES = {
  CONVERSATION: 'conversation',
  ALL: 'all',
};

export function isConversationScope(scope) {
  return scope === TASK_SCOPES.CONVERSATION;
}

export function nextTaskScope(scope) {
  return isConversationScope(scope)
    ? TASK_SCOPES.ALL
    : TASK_SCOPES.CONVERSATION;
}

export function isOpenTask(task) {
  if (!task) return false;
  if (task.status?.is_terminal) return false;
  const key = task.status_key || task.status?.key;
  return key !== 'done' && key !== 'cancelled';
}

export function isOverdueTask(task, now = Date.now()) {
  if (!isOpenTask(task) || !task.due_at) return false;
  const due = new Date(task.due_at).getTime();
  return Number.isFinite(due) && due < now;
}
